<template>
	<div class="">
		<div class="row">
            <div class="col-md-12 mb-0"><h4>BRIGHT STORE PERFORMANCE</h4></div>
			
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-0">
						<hr class="p-0 m-0">
					</div>
				</div>
			</div>	

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-1">
						<el-form  class="mt-2" label-position="top" label-width="100px" :inline="true">
						
							<el-form-item label="">
								<el-select v-model="yearperformance" filterable multiple placeholder="Select Year" size="small">
									<el-option v-for="item3 in options.years" :key="'performance_'+item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="">
								<el-select v-model="monthgrowth" filterable placeholder="Select Month" size="small">
									<el-option v-for="item3 in options.months" :key="'performance_'+item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-radio-group v-model="areagrowth" size="small" name="area">
									<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="'performance_'+item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
								</el-radio-group>
							</el-form-item>

							<el-form-item v-if="false">
								<el-radio-group v-model="salesarea" size="small">
									<el-radio label="" border>Konsol</el-radio>
									<el-radio label="Sales Area I" border>SA 1</el-radio>
									<el-radio label="Sales Area II" border>SA 2</el-radio>
									<el-radio label="Sales Area III" border>SA 3</el-radio>
									<el-radio label="Sales Area IV" border>SA 4</el-radio>
									<el-radio label="Sales Area V" border>SA 5</el-radio>
								</el-radio-group>
							</el-form-item>

							<el-form-item>
								<el-select v-model="branchgrowth" clearable filterable placeholder="Select Branch" size="small" style="width:100%;" @change="handleBranchGrowthChange">
									<el-option v-for="item3 in store.list" :key="'performance_'+item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
									</el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item>
								<el-button type="primary" size="small" :loading="loading.performancegrowth" @click="applyFilterGrowth">Filter</el-button>
							</el-form-item>
							
						</el-form>
					</div>
				</div>
			</div>

			<div class="col-md-12">
				<div class="row">

					<div class="col-md-3">
						<div class="row">
							<div class="col-md-12 mb-3">
								<WidgetPurple :title="selectedBranchLabelGrowth" :data="performancegrowth.data.growth" :years="yearperformance" :loading="loading.performancegrowth"/>
							</div>
						</div>
					</div>

					<div class="col-md-3">
						<div class="row">
							<div class="col-md-12 mb-3">
								<WidgetOrange :title="selectedBranchLabelGrowth" :data="performancegrowth.data.growth" :years="yearperformance" :loading="loading.performancegrowth"/>
							</div>
						</div>
					</div>

					<div class="col-md-3">
						<div class="row">
							<div class="col-md-12 mb-3">
								<WidgetGreen :title="selectedBranchLabelGrowth" :data="performancegrowth.data.growth" :years="yearperformance" :loading="loading.performancegrowth"/>
							</div>
						</div>
					</div>

					<div class="col-md-3">
						<div class="row">
							<div class="col-md-12 mb-3">
								<WidgetGrey :title="selectedBranchLabelGrowth" :data="performancegrowth.data.growth" :years="yearperformance" :loading="loading.performancegrowth"/>
							</div>
						</div>
					</div>
					
				</div>
			</div>

			<div class="col-md-12 mt-2 mb-4">
				<el-card shadow="hover" :body-style="{ padding: '10px 10px' }">
					<div slot="header">
						<h5 class="text-center m-0 px-2">TREND SALES PER DAY BRIGHT STORE</h5>
					</div>
					<div>
						<BarChart  v-loading.body="loading.performancegrowth" :data="barcharttrend" :width="500" :height="350" />
					</div>
				</el-card>
			</div>

			<div class="col-md-12 mb-0 mt-2"><h4>NET SALES & SALES PER DAY</h4></div>
			
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-0">
						<hr class="p-0 m-0">
					</div>
				</div>
			</div>	

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-1">
						<el-form  class="mt-2" label-position="top" label-width="100px" :inline="true">
						
							<el-form-item label="">
								<el-select v-model="yearnettsales" filterable placeholder="Select Year" size="small">
									<el-option v-for="item3 in options.years" :key="'net_'+item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="">
								<el-select v-model="monthnettsales" filterable placeholder="Select Month" size="small">
									<el-option v-for="item3 in options.months" :key="'net_'+item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-radio-group v-model="areanettsales" size="small" name="area">
									<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="'net_'+item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
								</el-radio-group>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" size="small" :loading="loading.topbottomsales" @click="applyFilterTopBottomSales">Filter</el-button>
							</el-form-item>

						</el-form>
					</div>
				</div>
			</div>

			<div class="col-md-12">
				<div class="row">
                    <div class="col-md-6 mb-4">
                        <BrightStoreTopTen :title="'10 NET SALES TERTINGGI'" :data="reportdata?.data?.top_net_sales" :loading="loading.topbottomsales"/>
                    </div>
					<div class="col-md-6 mb-4">
                        <BrightStoreTopTen :title="'10 NET SALES TERENDAH'" :data="reportdata?.data?.bottom_net_sales" :loading="loading.topbottomsales"/>
                    </div>
                </div>

				<div class="row">
                    <div class="col-md-6 mb-4">
                        <BrightStoreTopTen :title="'10 SALES PER DAY TERTINGGI'" :data="reportdata?.data?.top_spd" :loading="loading.topbottomsales"/>
                    </div>
					<div class="col-md-6 mb-4">
                        <BrightStoreTopTen :title="'10 SALES PER DAY TERENDAH'" :data="reportdata?.data?.bottom_spd" :loading="loading.topbottomsales"/>
                    </div>
                </div>
			</div>

			<div class="col-md-12 mb-0"><h4>TOP MARKET SHARE</h4></div>
			
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-0">
						<hr class="p-0 m-0">
					</div>
				</div>
			</div>	

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-1">
						<el-form  class="mt-2" label-position="top" label-width="100px" :inline="true">
						
							<el-form-item label="">
								<el-select v-model="yearmarket" filterable placeholder="Select Year" size="small">
									<el-option v-for="item3 in options.years" :key="'market_'+item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="">
								<el-select v-model="monthmarket" filterable clearable placeholder="Select Month" size="small">
									<el-option v-for="item3 in options.months" :key="'market_'+item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-radio-group v-model="areamarket" size="small" name="area">
									<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="'market_'+item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
								</el-radio-group>
							</el-form-item>

							<el-form-item>
								<el-select v-model="branchmarket" clearable filterable placeholder="Select Branch" size="small" style="width:100%;" @change="handleBranchMarketChange">
									<el-option v-for="item3 in store.list" :key="'market_'+item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" size="small" :loading="loading.marketshare" @click="applyFilterMarket">Filter</el-button>
							</el-form-item>

						</el-form>
					</div>
				</div>
			</div>

			<div class="col-md-12 mt-0">
				<el-card shadow="hover" :body-style="{ padding: '10px 10px' }">
					<div slot="header">
						<h5 class="text-center m-0 px-2">TOP MARKET SHARE</h5>
					</div>
					<div>
						<BarChart  v-loading.body="loading.marketshare" :data="barchartmarketshare" :width="500" :height="450" />
					</div>
				</el-card>
			</div>

		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { AxiosWithJar, Config, AppColors, Penanggalan} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'

import BarChart from '@/components/chart/BarChart.js'
import LineChart from '@/components/chart/LineChart.js'

import BrightStoreTopTen from '@/views/pages/BrightStore/BrightStorePerformance/BrightStoreTopTen.vue'

import WidgetPurple from '@/views/pages/BrightStore/BrightStorePerformance/Component/WidgetPurple.vue'
import WidgetOrange from '@/views/pages/BrightStore/BrightStorePerformance/Component/WidgetOrange.vue'
import WidgetGreen from '@/views/pages/BrightStore/BrightStorePerformance/Component/WidgetGreen.vue'
import WidgetGrey from '@/views/pages/BrightStore/BrightStorePerformance/Component/WidgetGrey.vue'

export default
{
	extends: Bright,
	components: { 
        BrightStoreTopTen,
		WidgetPurple,
		WidgetOrange,
		WidgetGreen,
		WidgetGrey,
		BarChart,
		//ReportParamSelect,
		//ReportResultTable,
		//Loader,
	},

	data(){
		return {
			//growth performance
			//performancegrowth: [],
			//
			performancegrowth: {
				data : {
					growth: [],
					trend_spd: [],
				}
			},
			yearperformance: ['2023','2024'],
			monthgrowth: 1,
			areagrowth: '',
			branchgrowth: '',
			selectedBranchLabelGrowth: '',

			//nett sales & spd
			yearnettsales: Penanggalan().tahun,
			branchnettsales: '',
			monthnettsales: '',
			areanettsales: '',

			//market sahre
			marketsharedata: [],
			barchartmarketshare: [],
			yearmarket: Penanggalan().tahun,
			branchmarket: '',
			monthmarket: '',
			areamarket: '',
			
			year: 2024,
			month: 1,
			salesarea: "",
			barcharttrend: [],
			stacked: false,
			
			options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "INACTIVE" }, 
				],
				months:[
                    {value:'', name: 'All'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
				skema: [],
				flag: [],
			},
			tabList:[
				{name:'Store'},
			],

			loading: {
				performancegrowth: false,
				topbottomsales: false,
				marketshare: false,
			},

			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			//area: this.$route.query.area ? this.$route.query.area : '',
			//status: this.$route.query.status ? this.$route.query.status : '',
			branchid1: this.$route.query.branchid ? this.$route.query.branchid : '',
			skema: '',
			flag: '',
			showmap:false,

			reportdata:[],
			stationListMap:[],
			centeringMap:{},
			zoom:5, 
		}
	},
	watch:
	{
		/*
		yearperformance() {
			this.yearperformance.sort((a, b) => b - a);
		}
		*/
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
        /*
		reportdata() {
			this.stationListMap = this.reportdata["data"]
			.filter(e=> e.Latitude!==null && e.Longitude!==null)
			.map(item=>Object.assign(item,
				{id:item.BranchId,name:item.BPOSBranchName,lat:Number(item.Latitude.replace(',','.')),lng:Number(item.Longitude.replace(',','.'))}))
		
				console.log('list: ' + JSON.stringify(this.stationListMap))
		}
        */
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
		this.loadStoreList();
		this.getTopBottomSales();
		this.getPerformanceGrowth();
		this.getPerformanceMarketShare();
    },
    methods:{

		async getPerformanceGrowth() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/bright/brightperformancegrowth?'

            this.urlRequestParams += '&year='+this.yearperformance
			this.urlRequestParams += '&month='+this.monthgrowth
			this.urlRequestParams += '&area='+this.areagrowth
			this.urlRequestParams += '&branch='+this.branchgrowth
			

            this.loading.performancegrowth = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.performancegrowth = response.data;

					this.setBarchartTrendSpd();
					
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.performancegrowth = false;
				})
        },

		async getTopBottomSales() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/bright/brightperformancetopbottomsales?'

            this.urlRequestParams += '&year='+this.yearnettsales
			this.urlRequestParams += '&month='+this.monthnettsales
			this.urlRequestParams += '&area='+this.areanettsales
			this.urlRequestParams += '&branch='+this.branchnettsales

            this.loading.topbottomsales = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;
					
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.topbottomsales = false;
				})
        },

		async getPerformanceMarketShare() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/bright/brightperformancemarketshare?'

            this.urlRequestParams += '&year='+this.yearmarket
			this.urlRequestParams += '&month='+this.monthmarket
			this.urlRequestParams += '&area='+this.areamarket
			this.urlRequestParams += '&branch='+this.branchmarket
			
            this.loading.marketshare = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.marketsharedata = response.data;

					this.setBarchartMarketShare();
					
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.marketshare = false;
				})
        },

		setBarchartTrendSpd() {
            //console.log('this.maindata: ' + JSON.stringify(this.maindata))
            let label = 'Label'
            let value = 'Value'
            let legend = 'Legend'
            this.barcharttrend = this.processBarChart(this.performancegrowth.data.trend_spd, legend, '', value, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
        },

		setBarchartMarketShare() {
            //console.log('this.maindata: ' + JSON.stringify(this.maindata))
            let label = 'Label'
            let value = 'Value'
            let legend = 'Legend'
            this.barchartmarketshare = this.processBarChart(this.marketsharedata.data.market_share, legend, '', value, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
        },

		handleBranchGrowthChange(value) {
			const selectedBranch = this.store.list.find(
				(item) => item.BranchId === value
			);

			if(selectedBranch) {
				this.selectedBranchLabelGrowth = selectedBranch.BPOSBranchName;
				//console.log('Selected branch label:', this.selectedBranchLabel);
			}
		},

		handleBranchMarketChange(value) {

		},
		
		applyFilterGrowth() {
			this.getPerformanceGrowth()
        },

		applyFilterTopBottomSales() {
			this.getTopBottomSales()
        },

		applyFilterMarket() {
			this.getPerformanceMarketShare()
        },

    }
}
</script>
<style>


</style>